import { render } from "./BiogasOverview.vue?vue&type=template&id=9ece6de0"
import script from "./BiogasOverview.vue?vue&type=script&lang=js"
export * from "./BiogasOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__